import { render, staticRenderFns } from "./Antri.vue?vue&type=template&id=70bb9754"
import script from "./Antri.vue?vue&type=script&lang=js"
export * from "./Antri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports